import React from "react";
import { SingleCustomization } from "./SingleCustomization";

export const AllCustomizations = ({ chartManager }) => {
    return (
        <div style={{ flex: 1}}>
            <SingleCustomization chartManager={chartManager} stateKey="overview" />
        </div>
    );
};
